"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var hooks_1 = require("../../../../hooks");
var usePostJSON_1 = __importDefault(require("../../../../hooks/usePostJSON"));
var ConfigProvider_1 = require("../../../../providers/ConfigProvider");
var either_1 = require("../../../../utils/either");
var Button_1 = __importDefault(require("../../../Button/Button"));
var DateField_1 = __importDefault(require("../../../Form/fields/DateField"));
var Form_1 = __importDefault(require("../../../Form/Form"));
var EditEndComps_1 = require("../EditEndComps");
var Utils_1 = require("../Utils");
var validation = function (values) {
    var datumDoLens = ramda_1.lensProp('do');
    return ramda_1.pipe(ramda_1.when(function () { return !ramda_1.view(datumDoLens, values); }, ramda_1.set(datumDoLens, 'Datum ukončení je povinné.')))({});
};
var FormDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  div:not(:only-child):first-child {\n    padding: 0;\n  }\n"], ["\n  div:not(:only-child):first-child {\n    padding: 0;\n  }\n"])));
var PozastaveniCinnostiDialogForm = function (_a) {
    var _b, _c, _d, _e;
    var initialValues = _a.initialValues, onZrusit = _a.onZrusit, refetch = _a.refetch, znalecValues = _a.znalecValues, tlumocnikValues = _a.tlumocnikValues, isKancelar = _a.isKancelar;
    var _f = ConfigProvider_1.useConfig(), apiUrl = _f.apiUrl, typ = _f.typ;
    var iszrUrl = ConfigProvider_1.useConfig().iszrUrl;
    var postJSON = usePostJSON_1.default(apiUrl + "/ObnoveniOpravneni");
    var zmenOsobu = usePostJSON_1.default(iszrUrl + "/ZmenOsobu");
    var token = hooks_1.useToken();
    var submitted = hooks_1.useBoolean(false);
    var uzivatel = 'Anonymous';
    if (((_b = token.getDataFromToken()) === null || _b === void 0 ? void 0 : _b.name) || ((_c = token.getDataFromToken()) === null || _c === void 0 ? void 0 : _c.surname)) {
        uzivatel = ((_d = token.getDataFromToken()) === null || _d === void 0 ? void 0 : _d.name) + " " + ((_e = token.getDataFromToken()) === null || _e === void 0 ? void 0 : _e.surname);
    }
    var onSubmit = function (values, formikHelpers) { return __awaiter(void 0, void 0, void 0, function () {
        var obnoveniValues, response, zmenOsobuValues, _a, aktualizovatPozastaveni, aktivniPozastaveni, zanikAPreruseni, rosResponse, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    submitted.setTrue();
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 10, 11, 12]);
                    formikHelpers.setStatus(undefined);
                    obnoveniValues = {
                        idZnalec: typ === 'znalec' ? values.idZnalec : undefined,
                        idTlumocnik: typ === 'tlumocnik' ? values.idTlumocnik : undefined,
                        DatumDo: values.do,
                    };
                    return [4 /*yield*/, postJSON(obnoveniValues)];
                case 2:
                    response = _b.sent();
                    if (!either_1.isRight(response)) return [3 /*break*/, 8];
                    if (!refetch) return [3 /*break*/, 4];
                    return [4 /*yield*/, refetch()];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4:
                    if (!!isKancelar) return [3 /*break*/, 7];
                    zmenOsobuValues = void 0;
                    if (!(znalecValues || tlumocnikValues)) return [3 /*break*/, 7];
                    _a = response.value, aktualizovatPozastaveni = _a.aktualizovatPozastaveni, aktivniPozastaveni = _a.aktivniPozastaveni;
                    if (!aktualizovatPozastaveni) return [3 /*break*/, 7];
                    zanikAPreruseni = {
                        pozastaveniOpravneniBool: aktivniPozastaveni,
                        uzivatel: uzivatel,
                    };
                    if (znalecValues) {
                        zmenOsobuValues = Utils_1.znalecValuesForROS(znalecValues, zanikAPreruseni);
                    }
                    if (tlumocnikValues) {
                        zmenOsobuValues = Utils_1.tlumocnikValuesForROS(tlumocnikValues, zanikAPreruseni);
                    }
                    return [4 /*yield*/, zmenOsobu(zmenOsobuValues)];
                case 5:
                    rosResponse = _b.sent();
                    formikHelpers.setSubmitting(false);
                    if (either_1.isRight(rosResponse))
                        formikHelpers.setStatus({ message: 'Referenční údaje byly úspěšně aktualizovány v ROS.', type: 'success' });
                    else
                        formikHelpers.setStatus({ message: rosResponse.value.message, type: 'error' });
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 3000); })];
                case 6:
                    _b.sent();
                    _b.label = 7;
                case 7:
                    onZrusit();
                    return [3 /*break*/, 9];
                case 8:
                    formikHelpers.setStatus({ message: response.value.message, type: 'error' });
                    _b.label = 9;
                case 9: return [3 /*break*/, 12];
                case 10:
                    e_1 = _b.sent();
                    console.error(e_1);
                    formikHelpers.setStatus({ message: 'Během úpravy pozastavení činnosti nastala chyba.', type: 'error' });
                    return [3 /*break*/, 12];
                case 11:
                    formikHelpers.setSubmitting(false);
                    return [7 /*endfinally*/];
                case 12: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(FormDiv, null,
        react_1.default.createElement(Form_1.default, { initialValues: initialValues || {}, validate: validation, onSubmit: onSubmit }, function (_a) {
            var isSubmitting = _a.isSubmitting;
            return (react_1.default.createElement(EditEndComps_1.EditEndDialog, null,
                react_1.default.createElement(EditEndComps_1.EditEndDialogText, null, "Ukon\u010Dit pozastaven\u00ED \u010Dinnosti"),
                react_1.default.createElement(DateField_1.default, { label: "Datum ukon\u010Den\u00ED:", name: "do", toolTip: "Vyberte datum ukon\u010Den\u00ED pozastaven\u00ED \u010Dinnosti", minDate: (initialValues === null || initialValues === void 0 ? void 0 : initialValues.od) ? new Date(initialValues.od) : undefined, readOnly: submitted.value }),
                (!submitted.value || isSubmitting) && (react_1.default.createElement(EditEndComps_1.EditEndButtonsWrap, null,
                    react_1.default.createElement(Button_1.default, { type: "button", primary: false, loading: isSubmitting, onClick: onZrusit, name: "Zrusit", disabled: submitted.value }, "ZRU\u0160IT"),
                    react_1.default.createElement(Button_1.default, { type: "submit", primary: true, loading: isSubmitting, name: "Ukoncit", disabled: submitted.value }, "UKON\u010CIT POZASTAVEN\u00CD")))));
        })));
};
PozastaveniCinnostiDialogForm.defaultProps = {
    initialValues: undefined,
    refetch: undefined,
    znalecValues: undefined,
    tlumocnikValues: undefined,
    isKancelar: undefined,
};
exports.default = PozastaveniCinnostiDialogForm;
var templateObject_1;
